(() => {
  const hoverQuery = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');

  const track = (action, source, label, menu) => {
    const payload = {
      event: 'zentein_navigation',
      navigation_action: action,
      navigation_source: source || 'unknown',
      navigation_label: label || '',
      navigation_menu: menu || '',
      navigation_path: window.location.pathname
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    window.dispatchEvent(new CustomEvent('zentein:navigation', { detail: payload }));
  };

  const loadVisuals = (details) => {
    details.querySelectorAll('img[data-z-nav-image-src]').forEach((image) => {
      if (image.dataset.zNavImageLoaded === 'true') return;
      image.dataset.zNavImageLoaded = 'true';
      image.src = image.dataset.zNavImageSrc;
    });
  };

  const bind = (root = document) => {
    root.querySelectorAll('[data-z-nav-action]').forEach((link) => {
      if (link.dataset.zNavClickBound === 'true') return;
      link.dataset.zNavClickBound = 'true';
      link.addEventListener('click', () => {
        track(
          link.dataset.zNavAction,
          link.dataset.zNavSource,
          link.dataset.zNavLabel || link.textContent.trim(),
          link.closest('[data-z-nav-menu]')?.dataset.zNavMenu || ''
        );
      });
    });

    root.querySelectorAll('details[data-z-nav-menu]').forEach((details) => {
      if (details.dataset.zNavBound === 'true') return;
      details.dataset.zNavBound = 'true';

      const summary = details.querySelector(':scope > summary');
      const hoverHost = details.closest('header-menu');
      let closeTimer;

      const recordOpen = () => {
        if (!details.open || details.dataset.zNavOpenTracked === 'true') return;
        details.dataset.zNavOpenTracked = 'true';
        track(
          details.dataset.zNavOpenAction,
          details.dataset.zNavSource,
          summary?.textContent.trim() || details.dataset.zNavMenu,
          details.dataset.zNavMenu
        );
      };

      const syncOpenState = () => {
        if (!details.open) {
          details.dataset.zNavOpenTracked = 'false';
          return;
        }

        document.querySelectorAll('details[data-z-nav-menu][open]').forEach((other) => {
          if (other !== details && other.closest('.z-nav')) other.open = false;
        });
        loadVisuals(details);
        recordOpen();
      };

      details.addEventListener('toggle', syncOpenState);
      summary?.addEventListener('click', () => window.setTimeout(syncOpenState, 0));
      summary?.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') window.setTimeout(syncOpenState, 0);
      });

      if (hoverHost) {
        hoverHost.addEventListener('pointerenter', () => {
          if (!hoverQuery.matches) return;
          window.clearTimeout(closeTimer);
          details.open = true;
          syncOpenState();
        });

        hoverHost.addEventListener('pointerleave', () => {
          if (!hoverQuery.matches) return;
          closeTimer = window.setTimeout(() => {
            if (!details.contains(document.activeElement)) details.open = false;
          }, 180);
        });
      }

      details.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !details.open) return;
        event.preventDefault();
        details.open = false;
        details.dataset.zNavOpenTracked = 'false';
        summary?.focus();
      });

      details.addEventListener('focusout', () => {
        if (!hoverQuery.matches) return;
        window.setTimeout(() => {
          if (!details.contains(document.activeElement) && !details.matches(':hover')) details.open = false;
        }, 0);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bind(document), { once: true });
  } else {
    bind(document);
  }

  document.addEventListener('shopify:section:load', (event) => bind(event.target));
})();
